module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyLotion@2x_a19b0c.png";